/*
 * axios.ts
 */
import { defineBoot } from '#q-app/wrappers';
import type { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import axios from 'axios';
import type { Router } from 'vue-router';
//
import type { mtAxiosReturn } from 'src/config/config.type.axios';
import { vpseSystem } from 'src/stores/vpseSystem';
import { vpsUser } from 'src/user/vpsUser';
//
// 20230929 - v0.0.5b
// Cannot access the pinia store directly in boot file!!!
// const mpseSystem = vpseSystem();
// const mpsUser = vpsUser();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let mpseSystem: any = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let mpsUser: any = null;

let moVueRouter: Router;
//
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $axios: AxiosInstance;
  }
}
//
declare module 'axios' {
  export interface AxiosRequestConfig {
    _retry?: boolean;
  }
}
//
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const lbDEV: boolean = Boolean(process.env.DEV);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const lbDEBUGGING: boolean = Boolean(process.env.DEBUGGING);
// if (true === lbDEV || true === lbDEBUGGING) {
console.log('====================');
console.log('\nboot-axios.ts=[');
console.log('process.env.NODE_ENV=[', process.env.NODE_ENV, ']!');
console.log('process.env.APP_VERSION=[', process.env.APP_VERSION, ']!');
console.log('process.env.DEV=[', process.env.DEV, ']!');
console.log('process.env.PROD=[', process.env.PROD, ']!');
console.log('process.env.DEBUGGING=[', process.env.DEBUGGING, ']!');
console.log('process.env.CLIENT=[', process.env.CLIENT, ']!');
console.log('process.env.SERVER=[', process.env.SERVER, ']!');
console.log('process.env.MODE=[', process.env.MODE, ']!');
console.log('process.env.TARGET=[', process.env.TARGET, ']!');
console.log('process.env.APP_RUNTIME_CONTEXT=[', process.env.APP_RUNTIME_CONTEXT, ']!');
console.log('====================');
console.log('process.env.APP_URL=[', process.env.APP_URL, ']!');
console.log('process.env.API_URL=[', process.env.API_URL, ']!');
console.log('====================');
console.log('process.env.eLC_APP_URL=[', process.env.eLC_APP_URL, ']!');
console.log('boot-axios.ts=]\n');
console.log('====================');
// }
//
// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
// const api = axios.create({ baseURL: 'https://api.example.com' });
//
const eLCeSystemAPI = axios.create({ baseURL: process.env.API_URL });
//
// Interceptors
// Intercept requests or responses before they are handled by 'then' or 'catch'.
//
// REQUEST
//
eLCeSystemAPI.interceptors.request.use(
  function (poConfig: InternalAxiosRequestConfig) {
    //
    // 20230930: v0.0.5c
    //
    if (null === mpseSystem || null === mpsUser) {
      mpseSystem = vpseSystem();
      mpsUser = vpsUser();
    }
    //
    // console.log('\naxios.ts-eLCeSystemAPI.interceptors.request.use(poConfig.url)=[', poConfig.url, ']!');
    //
    if (true === mpseSystem.vcrGetIsLogin) {
      if ('/auth/refresh' !== poConfig.url) {
        //
        // normal axios request
        //
        poConfig.headers['Authorization'] = `Bearer ${mpsUser.vcrGetJWTAccess}`;
        //
        // console.log('axios.ts-eLCeSystemAPI.interceptors.request.use()-JWTAccess!');
        //
      } else {
        //
        // JWT Refresh in process!!!
        //
        poConfig.headers['Authorization'] = `Bearer ${mpsUser.vcrGetJWTRefresh}`;
        //console.log(
        //  `axios.ts-eLCeSystemAPI.interceptors.request.use(JWTRefresh)=[baseURL="${poConfig.baseURL}", method="${poConfig.method}", url="${poConfig.url}"]!`
        //);
      }
    }
    return poConfig;
  },
  function (poError: AxiosError | Error) {
    // console.error(
    //   `axios.ts-eLCeSystemAPI.interceptors.request.use(poError.status,poError.statusText)=
    //   [${poError.status}],[${poError.statusText}]!`,
    // );
    // console.error(
    //   `axios.ts-eLCeSystemAPI.interceptor.request.use():poConfig.method,url=
    //   [${poError.config.method}],[${poError.config.url}]!`,
    // );
    if (axios.isAxiosError(poError)) {
      const lstErrorMessage = poError.message;
      const linResponseStatus = poError.response.status;
      const lstResponseStatusText = poError.response.statusText;
      const lstConfigMethod = poError.config.method;
      const lstConfigURL = poError.config.url;
      const lstMessage =
        `axios.ts-eLCeSystemAPI.interceptors.request.use()` +
        `\n[lstErrorMessage]=[${lstErrorMessage}]` +
        `\n[linResponseStatus]=[${linResponseStatus}]` +
        `\n[lstResponseStatusText]=[${lstResponseStatusText}]` +
        `\n[lstConfigMethod]=[${lstConfigMethod}]` +
        `\n[lstConfigURL]=[${lstConfigURL}]!`;
      console.error(lstMessage);
    }
    return Promise.reject(poError);
    //
  },
);
//
// RESPONSE
//
eLCeSystemAPI.interceptors.response.use(
  function (poResponse: AxiosResponse) {
    return poResponse;
  },
  async function (poError: AxiosError | Error) {
    //
    // 20230930: v0.0.5c
    //
    if (null === mpseSystem || null === mpsUser) {
      mpseSystem = vpseSystem();
      mpsUser = vpsUser();
    }
    //
    // console.error(
    //   `axios.ts-eLCeSystemAPI.interceptors.resposnse.use(poError.response.status,statusText)=
    //   [${poError.response.status}],[${poError.response.statusText}]!`
    // );
    // console.error(
    //   `axios.ts-eLCeSystemAPI.interceptors.resposnse.use(poError.config.method,url,_retry)=
    //   [${poError.config.method}],[${poError.config.url}],[${poError.config._retry}]!`
    // );
    //
    if (axios.isAxiosError(poError)) {
      const loConfigOriginal = poError.config;
      if ('/auth/refresh' === loConfigOriginal.url /* || '/auth/logout' === loConfigOriginal.url*/) {
        //
        // 20231022-chaihs: When mpsUser.mfHandleAuthRefresh() called failed,
        // i.e. an error exception is return, need to termiate the calling loop!!!
        //
        return Promise.reject(poError);
      }
      if ('/auth/local/login' !== loConfigOriginal.url && poError.response) {
        if (401 === poError.response.status && !loConfigOriginal._retry) {
          //
          // axios request failed!!!
          // JWT Access token expired, 1st attempt to do JWT Refresh process
          //
          loConfigOriginal._retry = true;
          const loAuthRefresh: mtAxiosReturn = await mpsUser.mfHandleAuthRefresh();
          if (false === loAuthRefresh.cpibIsError) {
            // JWT Refresh process OK, continue to proceed with actual axios request
            // console.log('axios.ts-eLCeSystemAPI.interceptors.response.use()=[RefreshTokenOK]!');
            return await eLCeSystemAPI(loConfigOriginal);
          } else {
            // JWT Refresh token expired or ?error?
            // console.error('axios.ts-eLCeSystemAPI.interceptors.response.use()=[RefreshTokenExpired]!');
            void moVueRouter.push({ name: 'vrtAuthRefreshError' });
          }
        }
      }
    }
    //
    return Promise.reject(poError);
  },
);
//
// NOTE: 20240820 - QUASAR v2.16.9
// Anatomy of a boot file
// A boot file is a simple JavaScript file which can optionally export a function.
// Quasar will then call the exported function when it boots the application and
// additionally pass an object with the following properties to the function:
// Prop name
// app:        Vue App instance
// router:     Instance of Vue Router from 'src/router/index.js'
// store:      Instance of the Pinia or the Vuex store - store only will be
//             passed if your project used Pinia (you have src/stores) or
//             Vuex (you have src/store)
// ssrContext: Available on on server-side, if building SSR
// urlPath:    The pathname (path + search) part of the URL. It also contains the
//             hash on client-side.
// publicPath: The configured public path
// redirect:   Function to call to redirect another URL. Accepts String (full URL)
//             or a Vue Router Location String or Object
//
// export default boot((poBoot) => {
//   // for use inside Vue files (Options API) through this.$axios and this.$api
//   poBoot.app.config.globalProperties.$axios = axios;
//   // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
//   //       so you won't necessarily have to import axios in each vue file
//   // app.config.globalProperties.$api = api;
//   poBoot.app.config.globalProperties.$api = eLCeSystemAPI;
//   // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
//   //       so you can easily perform requests against your app's API
//   //
//   // 20230929 - v0.0.5b, 20240820 - v0.6.7a
//   mpseSystem = vpseSystem(poBoot.store);
//   mpsUser = vpsUser(poBoot.store);
//   // 20240820 - v0.6.7a
//   moVueRouter = poBoot.router;
//   //
//   // console.log(
//   //   '\naxios.ts-boot()=[',
//   //   '\nmpseSystem',
//   //   mpseSystem,
//   //   '\nmpsUser',
//   //   mpsUser,
//   //   '\nmoVueRouter',
//   //   moVueRouter,
//   //   ']!\n',
//   // );
//   //
// });
//
// NOTE: 20240928: without boot()
//
export default defineBoot(({ app, router, store }) => {
  app.config.globalProperties.$axios = axios;
  app.config.globalProperties.$api = eLCeSystemAPI;
  //
  mpseSystem = vpseSystem(store);
  mpsUser = vpsUser(store);
  //
  moVueRouter = router;
});

// export { api };
export { eLCeSystemAPI };

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    if (true === Boolean(process.env.CLIENT)) {
      window.location.reload();
    }
  });
}
